/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CbOrgStatusEnum } from './cbOrgStatusEnum';


export interface CBChildOrgModifiableAttribute { 
    /**
     * CSP org id
     */
    csp_org_id?: string;
    /**
     * Carbon black child org key
     */
    cb_org_id?: number;
    /**
     * Carbon black org name
     */
    org_name?: string;
    cb_org_status?: CbOrgStatusEnum;
    /**
     * Carbon black parent org key
     */
    cb_parent_org_key?: string;
    /**
     * Carbon black pop id
     */
    cb_pop_id?: string;
    /**
     * Carbon black user email
     */
    contact_email?: string;
    /**
     * Carbon black user first name
     */
    contact_first_name?: string;
    /**
     * Carbon black user last name
     */
    contact_last_name?: string;
    /**
     * RWR deactivation deployment id
     */
    deprovision_rwr_deployment_id?: string;
    /**
     * RWR activation deployment id
     */
    provision_rwr_deployment_id?: string;
    /**
     * User who created parent org entity
     */
    ref_count?: number;
}
export namespace CBChildOrgModifiableAttribute {
}


